<template>
  <!-- 音频文件播放器 -->
  <audio ref="audio" controls>
    <source :src="audioInfo.audioUrl" type="audio/mp3" />
  </audio>
</template>

<script>
export default {
  name: 'AudioBar',
  props: ['audioInfo'],
  watch: {
    audioInfo: {
      deep: true,
      immediate: true,
      handler() {
        // 更换路径后必须调用load方法才可以让新路径生效
        this.$nextTick(() => {
          this.$refs.audio.load();
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
audio {
  height: 30px;
  width: 60vw;
}
</style>
